import * as React from 'react';
import {
  Container,
  ButtonProps,
  ButtonVariant,
  ButtonScale,
} from './Button';

export type ButtonLinkProps
  = React.AnchorHTMLAttributes<HTMLAnchorElement> & Pick<ButtonProps,
    | 'variant'
    | 'scale'
    | 'stretched'>;

/**
 * This component inherits the button styles and converts them to a link.
 * @param {ButtonLinkProps} props
 * @return {React.ReactElement<ButtonLinkProps>}
 * @constructor
 */
function ButtonLink(
    props: ButtonLinkProps,
): React.ReactElement<ButtonLinkProps> {
  return (
    // @ts-ignore
    <Container as="a" {...props} />
  );
}

ButtonLink.defaultProps = {
  variant: ButtonVariant.Default,
  scale: ButtonScale.Medium,
};

export default ButtonLink;
